import { css } from '@emotion/react';

export const buttonContainer = css({
  marginTop: 80,
  width: '320px'
});
